var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[_c('span',{staticClass:"p1 is-bold",domProps:{"textContent":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }